import { render, staticRenderFns } from "./InvoiceOrder.vue?vue&type=template&id=37e0f0ad&scoped=true&"
import script from "./InvoiceOrder.vue?vue&type=script&lang=ts&"
export * from "./InvoiceOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0f0ad",
  null
  
)

export default component.exports